import { render, staticRenderFns } from "./Tab-VI.vue?vue&type=template&id=38054866"
import script from "./Tab-VI.vue?vue&type=script&lang=js"
export * from "./Tab-VI.vue?vue&type=script&lang=js"
import style0 from "./Tab-VI.vue?vue&type=style&index=0&id=38054866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports